import { render, staticRenderFns } from "./moveTo.vue?vue&type=template&id=f9d3af4a&scoped=true&"
import script from "./moveTo.vue?vue&type=script&lang=js&"
export * from "./moveTo.vue?vue&type=script&lang=js&"
import style0 from "./moveTo.vue?vue&type=style&index=0&id=f9d3af4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d3af4a",
  null
  
)

export default component.exports